import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const assetsAnalyticsDataViewCreateEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(() =>
		import(
			/* webpackChunkName: "async-assets-analytics-data-view-create-entrypoint" */ './index.tsx'
		).then((module) => module.AssetsAnalyticsDataViewCreatePage),
	),
	getPreloadProps: () => ({}),
});
